import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LandingPage from '../pages/Landing';
import LoginPage from '../pages/Login';
import SignUpPage from '../pages/SignUp';
import RunMonitorPage from '../pages/RunMonitor';
import DashboardPage from '../pages/Dashboard';
import NewTestRunPage from '../pages/NewTestRun';
import ResultsPage from '../pages/Results';
import IntegrationsPage from '../pages/Integrations';
import SettingsPage from '../pages/Settings';
import HistoryPage from '../pages/History';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="/landing" element={<LandingPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/sign-up" element={<SignUpPage />} />
    <Route path="/SignUp" element={<SignUpPage />} />
    <Route path="/run-monitor" element={<RunMonitorPage />} />
    <Route path="/RunMonitor" element={<RunMonitorPage />} />
    <Route path="/dashboard" element={<DashboardPage />} />
    <Route path="/new-test-run" element={<NewTestRunPage />} />
    <Route path="/NewTestRun" element={<NewTestRunPage />} />
    <Route path="/results" element={<ResultsPage />} />
    <Route path="/integrations" element={<IntegrationsPage />} />
    <Route path="/settings" element={<SettingsPage />} />
    <Route path="/profile" element={<SettingsPage />} />
    <Route path="/history" element={<HistoryPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default AppRoutes;
